import React from 'react';
import { Building, Wrench, FileWarning, Users, AlertCircle, Archive } from 'lucide-react';

const CARDS = [
  {
    icon: Building,
    title: '120 units, one Downloads folder',
    body:
      'A property manager runs 8 buildings, 120 units, 110 active leases. Every week brings 60-plus loose files: lease addenda, vendor invoices, work orders, owner statements, tenant disputes. They all land in one Downloads folder and the routing into Buildium or the shared drive happens manually.',
  },
  {
    icon: Wrench,
    title: 'Maintenance reports filed to the wrong unit',
    body:
      'Plumber finishes a call. The work order PDF gets emailed over with a vague filename like 240412_invoice.pdf. Someone files it under the wrong unit. Three months later the tenant asks about the leak history and you cannot find the original work order.',
  },
  {
    icon: FileWarning,
    title: 'Lease lifecycle docs scattered',
    body:
      'A lease has an application, a screening report, the signed lease, addenda, renewal notices, lease violations, eviction filings, move-out inspection, and security deposit reconciliation. Across 110 leases that is 1,500 documents that need to live under the right lease, not just the right unit.',
  },
  {
    icon: Users,
    title: 'Tenant ledgers and owner statements piled together',
    body:
      'Monthly accounting exports from Buildium or Rent Manager land in a single folder. The owner statements need to go to owners; the tenant ledgers need to go in tenant folders; the property-level reconciliations need to stay with the building. Splitting by hand is a multi-hour monthly task.',
  },
  {
    icon: AlertCircle,
    title: 'Regulatory retention is invisible',
    body:
      'Fair Housing requires record retention. State-specific rules add their own retention rules for security deposits, eviction filings, and lease applications. When everything lives in one flat folder, retention compliance is effectively impossible to audit.',
  },
  {
    icon: Archive,
    title: 'Move-out chaos',
    body:
      'A unit turns. You need the original lease, the security deposit receipt, the move-in inspection, every work order, the move-out inspection, and the deposit disposition. These live across five folders or, worse, scattered across three different platforms. Pulling them together is a half-day job.',
  },
];

const PainPoints = () => {
  return (
    <section id="problem" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          The property management filing problem
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Six patterns we hear from independent property managers, multifamily operators, and HOA
          managers running on Buildium, Rent Manager, or a shared drive.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {CARDS.map((card, i) => {
          const Icon = card.icon;
          return (
            <div key={i} className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6">
              <div className="w-10 h-10 rounded-full bg-sortio-secondary/15 border border-sortio-secondary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-secondary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{card.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{card.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default PainPoints;
